const initstate = {
  indexData: {},
  newIndexData: {},
  home4Products: {},
  zhHomeAdv: {},
  autoCompleteSearch: [],
  trplusOtherAlsoLikeProducts: [],
  FloatMenuData: [],
  mobileCategoryMenuData: [],
  mobileBrandMenuData: [],
  otherAlsoBuyProducts: [],
};

export function indexState(state = initstate, action) {
  switch (action.type) {
    case 'GET_INDEX_DATA': {
      return {
        ...state,
        indexData: action.payload,
      };
    }
    case 'GET_NEW_INDEX_DATA': {
      return {
        ...state,
        newIndexData: action.payload,
      };
    }
    case 'GET_HOME_PRODUCTS': {
      return {
        ...state,
        home4Products: action.payload,
      };
    }
    case 'GET_ZHHOME_ADV': {
      return {
        ...state,
        zhHomeAdv: action.payload,
      };
    }
    case 'UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT': {
      return {
        ...state,
        trplusOtherAlsoLikeProducts: action.payload,
      };
    }
    case 'UPDATE_FLOATMENUDATA': {
      return {
        ...state,
        FloatMenuData: action.payload,
      };
    }
    case 'UPDATE_MOBILE_CATEGORY_MENU_DATA': {
      return {
        ...state,
        mobileCategoryMenuData: action.payload,
      };
    }
    case 'UPDATE_MOBILE_BRAND_MENU_DATA': {
      return {
        ...state,
        mobileBrandMenuData: action.payload,
      };
    }
    case 'GET_AUTO_COMPLETE_SEARCH': {
      return {
        ...state,
        autoCompleteSearch: action.payload,
      };
    }
    case 'UPDATE_OTHERALSOBUYPRODUCT': {
      return {
        ...state,
        otherAlsoBuyProducts: action.payload,
      };
    }
    default:
      return state;
  }
}

export default indexState;
